import { memo, useEffect, useRef } from "react";

const BranchMarkers = ({
  branches,
  onSelect,
  mapRef,
  selectedBranch,
  updateSelectedBranch,
}) => {
  const markersRef = useRef({});

  useEffect(() => {
    if (!mapRef.current || !window.google) return;
    if (!window.google?.maps?.marker?.AdvancedMarkerElement) return;

    branches.forEach((branch) => {
      const lat = Number(branch.location?.latitude);
      const lng = Number(branch.location?.longitude);

      if (isNaN(lat) || isNaN(lng)) return;

      const exists = markersRef.current[branch._id];

      if (!exists) {
        const img = document.createElement("img");
        img.style.width = "55px";

        const marker = new google.maps.marker.AdvancedMarkerElement({
          position: { lat, lng },
          content: img,
          map: branch.hide ? null : mapRef.current,
        });

        marker.addListener("click", () => {
          onSelect({
            ...branch,
            _marker: marker,
            _position: { lat, lng },
          });
        });

        markersRef.current[branch._id] = { marker, img };
      }

      const { marker, img } = markersRef.current[branch._id];

      img.src = `${process.env.REACT_APP_PUBLIC_URL}${
        Array.isArray(branch.orders) && branch.orders.length > 0
          ? "icons/markers/active_branch_marker.png"
          : "icons/markers/inactive_branch_marker.png"
      }`;

      marker.position = { lat, lng };

      if (branch.hide) {
        marker.map = null;
      } else {
        marker.map = mapRef.current;
      }

      if (selectedBranch?._id === branch._id && updateSelectedBranch) {
        updateSelectedBranch({
          ...branch,
          _marker: marker,
          _position: { lat, lng },
        });
      }
    });

    Object.keys(markersRef.current).forEach((id) => {
      if (!branches.find((b) => b._id === id)) {
        markersRef.current[id].marker.map = null;
        delete markersRef.current[id];
      }
    });
  }, [branches, selectedBranch, updateSelectedBranch, mapRef]);

  return null;
};

export default memo(BranchMarkers);
